<div class="user-modules-container">
  <!-- Filters Panel -->
  <div class="panel panel-default">
    <div class="panel-heading">Filters:</div>
    <div class="panel-body filters-body">
      <div class="filter-col">
        <label>Select client:</label>
        <select class="form-control input-sm" [(ngModel)]="client_key"
                (ngModelChange)="getJurisByClientKey()">
          @for (client of allActiveClients; track $index) {
<option [ngValue]="client.client_key">
            {{ client.client_name }}
          </option>
}
        </select>
      </div>
      <div class="filter-col">
        <label>Application:</label>
        <select class="form-control input-sm" [(ngModel)]="selectedApplication"
                (ngModelChange)="setApplication(selectedApplication)">
          <option [ngValue]="null">-- All --</option>
          @for (app of userAssignNav; track $index) {
<option [ngValue]="app">{{ app.name }}</option>
}
        </select>
      </div>
    </div>
    <div class="panel-footer">
      <strong>Note:</strong>&nbsp;
      <span [class.status-error]="showValidationErrors || userPreviouslyHadModules">{{ userMessage }}</span>
    </div>
  </div>

  <!-- Templates Panel -->
  @if (allTemplatesList.length > 0) {
<div class="panel panel-default">
    <div class="panel-heading template-header">
      <span>Templates:</span>
      <div class="template-actions">
        <button class="btn btn-sm btn-success"
                (click)="validateBeforeApplyTemplate()"
                [disabled]="selectedTemplates.length === 0 || loading">
          <i class="fa fa-check"></i> Apply Template
        </button>
        <button class="btn btn-sm btn-danger"
                (click)="confirmRemoveAllAccess()"
                [disabled]="loading">
          <i class="fa fa-trash"></i> Remove All Access
        </button>
      </div>
    </div>
    <div class="panel-body template-body">
      <div class="template-list">
        @for (template of allTemplatesList; track trackByNodeId($index, template)) {
<label class="template-item"
               [class.selected]="isTemplateSelected(template.id)">
          <input type="checkbox"
                 [checked]="isTemplateSelected(template.id)"
                 (change)="toggleTemplateSelection(template)">
          <span>{{ template.label }}</span>
        </label>
}
      </div>
    </div>
  </div>
}

  <!-- Application Modules -->
  <div class="modules-section">
    <div class="modules-section-header">
      <span class="modules-title">Application Modules:</span>
      @if (enableModuleAssign === 'false') {
<span class="no-module-access">
        To assign module access, please go to the Template Assign Activity in the Admin Settings.
      </span>
}
      <div class="modules-actions">
        <button class="btn btn-sm btn-default button-lable" (click)="toggleAll()">
          <span class="fa button-labled" [ngClass]="allExpanded ? 'fa-folder' : 'fa-folder-open'"></span>
          {{ allExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
        <div class="search-wrapper">
          <i class="fa fa-search search-icon"></i>
          <input type="text" placeholder="Search Item..." [(ngModel)]="searchTerm"
                 (ngModelChange)="filterMenu(searchTerm)" class="search-input">
        </div>
      </div>
    </div>

    @if (loading) {
<div class="modules-loading">
      <ap-loading [size]="'24px'" [colorName]="'a-primary'"></ap-loading>
    </div>
}

    @if (!loading && filteredUserAssignNav.length > 0) {
<div class="modules-columns">
      @for (col of columns; track trackByIndex($index)) {
<div class="column">
        @for (node of col; track trackByNodeId($index, node)) {
<div class="module-card">
          <div class="activity-num" [ngClass]="node._badgeClass">
            {{ node._assigned || 0 }}/{{ node._total || 0 }}
          </div>
          <div class="card-header">
            <b class="ellip">{{ node.name }}</b>
            <span style="float:right">
              <i class="fa pls-icon" (click)="toggleNode(node)"
                 [ngClass]="node.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o'"></i>
            </span>
            <i class="fa fa-user-circle-o user"
               ap-tooltip [tooltipContent]="node._tooltip" [direction]="'left'"></i>
          </div>
          <div class="card-assign">
            <b>Assign:</b>&nbsp;
            <select class="assign-dropdown" [(ngModel)]="node._bulkDropdown"
                    (ngModelChange)="changeGroupRole(node._bulkDropdown, node)"
                    [disabled]="enableModuleAssign === 'false'">
              <option value="" disabled>select Level</option>
              <option value="0">No Access</option>
              <option value="-1">Lowest Level</option>
              <option value="1">Highest Level</option>
            </select>
          </div>

          <!-- Expanded children section -->
          @if (!node.collapsed && node.children?.length) {
<div class="card-body">
            <div class="channel">{{ node.name }}</div>
            <div class="user-assign-btn-group">
              <button class="btn user-btn" (click)="openUserAccessModal(node)"
                      [disabled]="enableModuleAssign === 'false'">
                <i class="fa fa-user-circle user-icn"></i>Assign User
              </button>
            </div>

            <ng-container *ngTemplateOutlet="treeLevel; context: { $implicit: node }"></ng-container>
          </div>
}
        </div>
}
      </div>
}
    </div>
}

    @if (!loading && filteredUserAssignNav.length === 0) {
<div class="no-data">
      No modules found.
    </div>
}
  </div>
</div>

<!-- Recursive tree-structure template -->
<ng-template #treeLevel let-parentNode>
  <ul class="tree-structure">
    @for (ch of parentNode.children; track trackByNodeId($index, ch)) {
<li
        [class.has-children]="ch.children?.length">
      <div class="clearfix">
        <span class="task">{{ ch.name }}</span>
        @if (ch.roles?.length > 0) {
<div class="pull-right">
          <select class="child-select"
                  [ngModel]="ch.role?.value != null ? ch.role.value : ch.roles[0]?.value"
                  (ngModelChange)="onRoleSelectChange(ch, $event)"
                  [disabled]="enableModuleAssign === 'false'"
                  [class.has-access]="ch.role?.value > 0">
            @for (role of ch.roles; track $index) {
<option [value]="role.value">{{ role.label || role.name }}</option>
}
          </select>
        </div>
}
      </div>
      @if (ch.children?.length) {

        <ng-container *ngTemplateOutlet="treeLevel; context: { $implicit: ch }"></ng-container>
      
}
    </li>
}
  </ul>
</ng-template>

